import { render, staticRenderFns } from "./MkObjRadio.vue?vue&type=template&id=492ac4fd&"
import script from "./MkObjRadio.vue?vue&type=script&lang=js&"
export * from "./MkObjRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports